// import './Splash.css';

function NotFound() {

  
  return (
    <div style={{marginTop: '100px', height: '100%'}} className="main-content-box blue-border">
      <p>ERROR: Page not found</p>
      <p>Oops, you've somehow ended up at a page that doens't exist, please select an option from the navigation header at the top of the page to return to the website.</p>
    </div>
  );
}

export default NotFound;
